import React from "react";
import './styles.css';
import './styles/theme-variables.css';
import './components/hm-theme.css';
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";

import { createRoot } from 'react-dom/client';

// Now you can use createRoot to render your application
const root = createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);